import React from "react";
import styles from "./Opinions.module.scss";
import InfoIcon from "../../../../assets/img/info.png";
import Rating from "@material-ui/lab/Rating";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import SingleOpinion from "./SingleOpinion/SingleOpinion";
//import {ReactComponent as CalendarIcon2} from "./../../../../assets/svg/calendar.svg";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import Fade from "@material-ui/core/Fade";

class Opinions extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: null,
      hasResult: false,
    };
  }

  toggleTab = (tab) => {
    this.setState({
      hasResult: false,
    });
    this.setState({
      activeTab: tab,
    });
  };

  render() {
    const { opinions, lawyer } = this.props;
    const { activeTab, hasResult } = this.state;

    let opinionText = "opinii";
    if (opinions) {
      if (opinions.totalOpinionVerified === 1) opinionText = "opinia";
      else if (opinions.totalOpinionVerified < 5) opinionText = "opinie";
    }

    return (
      <Fade in={true} timeout={800}>
        <div className={styles.Opinions}>
          {/*<div className={styles.lawyerCard}>*/}
          {/*    <LawyerCard lawyer={lawyer}/>*/}
          {/*</div>*/}
          <div className={styles.info}>
            <img src={InfoIcon} alt="info icon" />
            <div>Dodawanie opinii będzie możliwe po skorzystaniu z usługi</div>
          </div>
          <hr />
          <div className={styles.generalOpinion}>
            <div className={styles.rate}>
              {opinions ? Math.round(opinions.average * 100) / 100 : "--"}
            </div>

            <div className={styles.rightCont}>
              <Rating
                name="star-rating"
                value={opinions.average}
                precision={0.5}
                className={styles.star}
                //size="small"
                readOnly
                icon={<StarRoundedIcon />}
                emptyIcon={<StarBorderRoundedIcon />}
              />
              <div>Ogólna ocena</div>
              <div className={styles.opinionsCount}>
                {opinions ? opinions.totalOpinionVerified : 0} {opinionText}
              </div>
            </div>
          </div>
          <hr />
          <div>
            <Button
              variant={!activeTab ? "contained" : "outlined"}
              color="primary"
              onClick={() => {
                this.toggleTab(null);
              }}
              className={styles.filtersButton}
            >
              Wszystkie opinie{" "}
              {opinions && <>({opinions.totalOpinionVerified})</>}
            </Button>

            <Button
              variant={activeTab === "pozytywnych" ? "contained" : "outlined"}
              color="primary"
              onClick={() => {
                this.toggleTab("pozytywnych");
              }}
              className={styles.filtersButton}
            >
              Pozytywne
            </Button>

            <Button
              variant={activeTab === "neutralnych" ? "contained" : "outlined"}
              color="primary"
              onClick={() => {
                this.toggleTab("neutralnych");
              }}
              className={styles.filtersButton}
            >
              Neutralne
            </Button>

            <Button
              variant={activeTab === "negatywnych" ? "contained" : "outlined"}
              color="primary"
              onClick={() => {
                this.toggleTab("negatywnych");
              }}
              className={styles.filtersButton}
            >
              Negatywne
            </Button>
          </div>
          <hr />
          <div className={styles.clientsOpinions}>
            {opinions &&
              opinions.opinions.map((opinion) => {
                if (
                  activeTab === null ||
                  (activeTab === "pozytywnych" && opinion.rate >= 4) ||
                  (activeTab === "neutralnych" &&
                    (opinion.rate === 2 || opinion.rate === 3)) ||
                  (activeTab === "negatywnych" && opinion.rate === 1)
                ) {
                  if (!this.state.hasResult) {
                    this.setState({
                      hasResult: true,
                    });
                  }
                  return <SingleOpinion opinion={opinion} key={opinion.id} />;
                }
              })}
            {!hasResult && (
              <div className={styles.noOpinionsd}>Brak {activeTab} opinii.</div>
            )}
          </div>
        </div>
      </Fade>
    );
  }
}

Opinions.defaultProps = {};

export default Opinions;
